var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-dropzone',{key:("" + (_vm.selected_language.key)),ref:"tincanDropzone2",staticClass:"dropzone-module-small w-25",attrs:{"id":"dropzone_lesson_list","options":_vm.dropzoneOptions,"url":_vm.dropzoneOptions.url},on:{"vdropzone-error":_vm.dropzoneFail,"vdropzone-success":_vm.attachmentUploaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20c23a58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sme/SharedViews/LessonDropZone.vue
// module id = null
// module chunks = 